import React, { useMemo } from 'react';
import { Box, Divider, Typography, Grid, Stack } from '@mui/material';
import { Icon } from '@iconify/react';
import GridLabels from '../VehicleTabs/GridLabels';
import TabLoader from '../VehicleTabs/TabLoader';
import useMetaData from '../../hooks/useMetaData';
import { jsonPathToValue } from '../../utils/json';
import applyType from '../../utils/metadataUtils';
import { generateRandomString } from '../../utils/string';
import { META_DATA_MODULES, META_DATA_SUB_MODULES } from '../../utils/constants';

type Props = {
  data: any;
};

const Registration = ({ data }: Props) => {
  // use hooks
  const metaData = useMetaData(META_DATA_MODULES.v360Page, META_DATA_SUB_MODULES.registrationTab);

  // constants
  const buyerFields = useMemo(
    () =>
      data
        ? metaData?.buyerDetails?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            if (row.property === 'dmvMailingAddress' && value?.replace?.(/,/g, '')?.trim() === '') {
              const value2 = jsonPathToValue(data, 'dmvRegistrationAddress');
              return {
                label: row?.propertyName,
                title: value2,
                id: generateRandomString(10),
                xs: row.xs,
                type: row?.type,
                isOptional: row?.isOptional,
              };
            }
            return {
              label: row?.propertyName,
              title: value,
              id: generateRandomString(10),
              xs: row.xs,
              type: row?.type,
              isOptional: row?.isOptional,
            };
          })
        : [],
    [data, metaData?.buyerDetails]
  );
  const buyerLicenseFields = useMemo(
    () =>
      data
        ? metaData?.buyerDetails?.licenseDetails?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            return {
              label: row?.propertyName,
              title: value,
              id: generateRandomString(10),
              xs: row.xs,
              type: row?.type,
              isOptional: row?.isOptional,
            };
          })
        : [],
    [data, metaData?.buyerDetails]
  );

  const coBuyerFields = useMemo(
    () =>
      data
        ? metaData?.coBuyerDetails?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            return {
              label: row?.propertyName,
              title: value,
              id: generateRandomString(10),
              xs: row.xs,
              type: row?.type,
              isOptional: row?.isOptional,
            };
          })
        : [],
    [data, metaData?.coBuyerDetails]
  );
  const coBuyerLicenseFields = useMemo(
    () =>
      data
        ? metaData?.coBuyerDetails?.licenseDetails?.rows?.map((row: any) => {
            const value = jsonPathToValue(data, row.property);
            return {
              label: row?.propertyName,
              title: value,
              id: generateRandomString(10),
              xs: row.xs,
              type: row?.type,
              isOptional: row?.isOptional,
            };
          })
        : [],
    [data, metaData?.coBuyerDetails]
  );

  if (!metaData || !data) return <TabLoader />;
  return (
    <>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: '500',
          borderBottom: '1px dashed #E3E3E3',
          paddingBottom: '12px',
          marginTop: '20px',
        }}
      >
        {metaData?.buyerDetails?.heading}
      </Typography>
      <Box my={3}>
        <Grid container spacing={2}>
          <GridLabels
            labels={buyerFields}
            labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
            titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
          />
        </Grid>
      </Box>

      <Stack>
        <Typography
          sx={{
            fontSize: '14px',
            fontWeight: '400',
            color: '#717171',
            paddingBottom: '8px',
          }}
        >
          {metaData?.buyerDetails?.licenseDetails?.heading}:
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            border: '1px solid #E9E9E9',
            padding: '12px 13px 9px 17px',
            borderRadius: '6px',

            paddingLeft: '62px',
            position: 'relative',
          }}
        >
          <Box sx={{ position: 'absolute', left: '10px' }}>
            <Icon icon="bi:file-pdf-fill" width="40" color="#C2B299" />
          </Box>
          <Grid container spacing={2} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            <GridLabels
              labels={buyerLicenseFields}
              labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
              titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
            />
            {/* <Grid item xs={3} sx={{ textAlign: 'right' }}>
                      <Link to="/" sx={{ fontSize: 14, fontWeight: 400, color: '#456BD9' }}>
                        View Document
                      </Link>
                    </Grid> */}
          </Grid>
        </Box>
      </Stack>

      {data?.buyer?.Check_if_Co_Buyer__c === true ||
        (data?.buyer?.Check_if_Co_Buyer__c === 'true' && (
          <>
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: '500',
                borderBottom: '1px dashed #E3E3E3',
                paddingBottom: '12px',
                marginTop: '20px',
              }}
            >
              {metaData?.coBuyerDetails?.heading}
            </Typography>
            <Box my={3}>
              <Grid container spacing={2}>
                <GridLabels
                  labels={coBuyerFields}
                  labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
                  titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
                />
              </Grid>
            </Box>

            <Stack>
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: '400',
                  color: '#717171',
                  paddingBottom: '8px',
                }}
              >
                {metaData?.coBuyerDetails?.licenseDetails?.heading}:
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  border: '1px solid #E9E9E9',
                  padding: '12px 13px 9px 17px',
                  borderRadius: '6px',

                  paddingLeft: '62px',
                  position: 'relative',
                }}
              >
                <Box sx={{ position: 'absolute', left: '10px' }}>
                  <Icon icon="bi:file-pdf-fill" width="40" color="#C2B299" />
                </Box>
                <Grid container spacing={2} sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                  <GridLabels
                    labels={coBuyerLicenseFields}
                    labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
                    titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
                  />
                  {/* <Grid item xs={3} sx={{ textAlign: 'right' }}>
                      <Link to="/" sx={{ fontSize: 14, fontWeight: 400, color: '#456BD9' }}>
                        View Document
                      </Link>
                    </Grid> */}
                </Grid>
              </Box>
            </Stack>
          </>
        ))}
    </>
  );
};

export default Registration;
